import { compose } from "redux";
import { RequestOperationType } from "../../../models/Operation";
import moment from "moment";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IRequestItem, IRequestItemRow } from "../../../models/Request";
import { RequestStatusType } from "../../../models/Status";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import {
  CALL_STATE_IDENTIFIER,
  CALL_STATE_IDENTIFIER_SAVE,
  CSV_REQUEST_LIST_IDENTIFIER,
  CSV_REQUEST_LOAD_IDENTIFIER,
  DETAIL_REQUEST_IDENTIFIER,
  DETAIL_REQUEST_LOADER_IDENTIFIER,
  HISTORY_REQUEST_LOADER,
  REQUEST_LIST_IDENTIFIER,
  SELECTED_REQUEST_IDENTIFIER,
} from "./constants";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const ACTION_HANDLERS = {
  [actionTypes.INIT_LOADER]: (state: any, action: any) =>
    immutableSet([HISTORY_REQUEST_LOADER], true, state),
  [actionTypes.HISTORY_REQUEST]: (state: any, action: any) =>
    immutableSet([HISTORY_REQUEST_LOADER], true, state),
  [actionTypes.HISTORY_SUCCESS]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    let { requests, ...paginationData } = action.payload;

    const fineResponse: IRequestItem[] = [];
    let sortingArr: IRequestItemRow[] = requests;

    sortingArr.length > 0 &&
      sortingArr.forEach((data: IRequestItemRow) => {
        const tempRow: IRequestItem = {
          id: data.id,
          internal_id: data.internal_id,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
          type: RequestOperationType[data.type],
          status: data.status ? RequestStatusType[data.status] : "ND",
          application: data.application ? data.application : "",
          entitlement: data.entitlement ? data.entitlement : "",
          beneficiary: data.beneficiary
            ? data.beneficiary_code
              ? `${data.beneficiary} [${data.beneficiary_code}]`
              : data.beneficiary
            : "",
          created_on: data.created_on
            ? moment(data.created_on).format("DD/MM/YYYY - HH:mm")
            : "",
          ticket_id: data.ticket_id ? data.ticket_id : "",
          applicant: data.applicant
            ? data.applicant_id
              ? `${data.applicant} [${data.applicant_id}]`
              : data.applicant
            : "",
          beneficiaryCompany: data.beneficiaryCompany
            ? data.beneficiaryCompany
            : "",
          applicantCompany: data.applicantCompany ? data.applicantCompany : "",
        };
        fineResponse.push(tempRow);
      });
    const mappedResponse = { ...paginationData, requests: fineResponse };
    return compose(
      immutableSet([REQUEST_LIST_IDENTIFIER], mappedResponse),
      immutableSet([HISTORY_REQUEST_LOADER], false)
    )(state);
  },
  [actionTypes.HISTORY_FAILURE]: (
    state: any,
    action: { type: string; payload: IRequestItem }
  ) => {
    return compose(
      immutableSet([SELECTED_REQUEST_IDENTIFIER], []),
      immutableSet([HISTORY_REQUEST_LOADER], false)
    )(state);
  },

  [actionTypes.FETCH_CSV_REQUEST]: (state: any, action: any) => {
    return immutableSet([CSV_REQUEST_LOAD_IDENTIFIER], false, state);
  },

  [actionTypes.FETCH_CSV_REQUEST_SUCCESS]: (state: any, action: any) => {
    const fineResponse: IRequestItem[] = [];
    let sortingArr: IRequestItemRow[] = action.payload;

    sortingArr.length > 0 &&
      sortingArr.forEach((data: IRequestItemRow) => {
        const tempRow: IRequestItem = {
          id: data.id,
          internal_id: data.internal_id,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
          type: RequestOperationType[data.type],
          status: data.status ? RequestStatusType[data.status] : "ND",
          application: data.application ? data.application : "",
          entitlement: data.entitlement ? data.entitlement : "",
          beneficiary: data.beneficiary
            ? data.beneficiary_code
              ? `${data.beneficiary} [${data.beneficiary_code}]`
              : data.beneficiary
            : "",
          created_on: data.created_on
            ? moment(data.created_on).format("DD/MM/YYYY - HH:mm")
            : "",
          ticket_id: data.ticket_id ? data.ticket_id : "",
          applicant: data.applicant
            ? data.applicant_id
              ? `${data.applicant} [${data.applicant_id}]`
              : data.applicant
            : "",
          beneficiaryCompany: data.beneficiaryCompany
            ? data.beneficiaryCompany
            : "",
          applicantCompany: data.applicantCompany ? data.applicantCompany : "",
        };
        fineResponse.push(tempRow);
      });
    return compose(
      immutableSet([CSV_REQUEST_LIST_IDENTIFIER], fineResponse),
      immutableSet([CSV_REQUEST_LOAD_IDENTIFIER], true)
    )(state);
  },

  [actionTypes.FETCH_CSV_REQUEST_FAILURE]: (state: any, action: any) => {
    return compose(
      immutableSet([CSV_REQUEST_LIST_IDENTIFIER], []),
      immutableSet([CSV_REQUEST_LOAD_IDENTIFIER], true)
    )(state);
  },

  [actionTypes.RETRY_REQUEST]: (state: any, action: string[]) => {
    return immutableSet([CALL_STATE_IDENTIFIER], IResponseState.PENDING, state);
  },
  [actionTypes.RETRY_REQUEST_SUCCESS]: (
    state: any,
    action: { type: string; payload: IRequestItem }
  ) => {
    return immutableSet([CALL_STATE_IDENTIFIER], IResponseState.SUCCESS, state);
  },
  [actionTypes.RETRY_REQUEST_FAILURE]: (
    state: any,
    action: { type: string; payload: IRequestItem }
  ) => {
    return immutableSet([CALL_STATE_IDENTIFIER], IResponseState.ERROR, state);
  },

  [actionTypes.SELECT_REQUEST]: (
    state: any,
    action: { type: string; payload: IRequestItem }
  ) => {
    return immutableSet([SELECTED_REQUEST_IDENTIFIER], action.payload, state);
  },

  [actionTypes.HISTORY_DETAIL]: (state: any, action: any) =>
    immutableSet([DETAIL_REQUEST_LOADER_IDENTIFIER], true, state),

  [actionTypes.HISTORY_DETAIL_SUCCESS]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    const reqDetail = { ...action.payload };
    if (
      action.payload.businessRoleInfo &&
      action.payload.businessRoleInfo.addedEntitlement.length > 0
    ) {
      reqDetail.businessRoleInfo.addedEntitlement.map((entitlement: any) => {
        return {
          ...entitlement,
          identitySystemId: entitlement.identity_system_id,
        };
      });
    }
    if (
      action.payload.businessRoleInfo &&
      action.payload.businessRoleInfo.deletedEntitlement.length > 0
    ) {
      reqDetail.businessRoleInfo.deletedEntitlement.map((entitlement: any) => {
        return {
          ...entitlement,
          identitySystemId: entitlement.identity_system_id,
        };
      });
    }
    return compose(
      immutableSet([DETAIL_REQUEST_IDENTIFIER], action.payload),
      immutableSet([DETAIL_REQUEST_LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.HISTORY_DETAIL_FAILURE]: (state: any, action: any) =>
    immutableSet([DETAIL_REQUEST_LOADER_IDENTIFIER], false, state),
  [actionTypes.CLEAR_DETAIL]: (state: any, action: any) =>
    immutableSet([DETAIL_REQUEST_IDENTIFIER], null, state),
  [actionTypes.CLEAR_DETAIL]: (state: any, action: any) =>
    immutableSet([DETAIL_REQUEST_IDENTIFIER], null, state),

  [actionTypes.DELETE_ATTACHMENT]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.PENDING, state),

  [actionTypes.DELETE_ATTACHMENT_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.SUCCESS, state),

  [actionTypes.DELETE_ATTACHMENT_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER], IResponseState.ERROR, state),

  [actionTypes.SAVE_ATTACHMENTS]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER_SAVE], IResponseState.PENDING, state),

  [actionTypes.SAVE_ATTACHMENTS_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER_SAVE], IResponseState.SUCCESS, state),

  [actionTypes.SAVE_ATTACHMENTS_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE_IDENTIFIER_SAVE], IResponseState.ERROR, state),
};

export default function communicationReducer(state = emptyState, action: any) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
